import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import axios from "axios";
import { API_URL } from "../../app/config";
import { ILogin } from "./loginModel";
import { ErrorToast, SuccessToast } from "../../components/toast/Toasts";

const initialState = {
  loading: false,
  error: "",
  data: null,
  otpData: null,
  mobile_no: "",
  resend: false,
  loginDetails: {
    UserID: localStorage.getItem("UserID") || "",
    Name: localStorage.getItem("Name") || "",
    UserName: localStorage.getItem("UserName") || "",
    EmailID: localStorage.getItem("EmailID") || "",
    UserTypeID: localStorage.getItem("UserTypeID") || "",
    UserType: localStorage.getItem("UserType") || "",
  },
};

export const generateOTP = createAsyncThunk(
  "UserLogin/OtpGenerate",
  async (mobile: any) => {
    try {
      const response = await axios.post(`${API_URL}/UserLogin/OtpGenerate`, {
        mobile_no: mobile,
      });
      SuccessToast(response.data?.Details || "Success");
      return response.data?.Data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error login:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const employeeLogin = createAsyncThunk(
  "userLogin/UserLogin",
  async (data: ILogin) => {
    try {
      const response = await axios.post(`${API_URL}/UserLogin/UserLogin`, data);
      SuccessToast(response.data?.Details || "Success");
      return response.data?.Data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error login:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

const loginSlice = createSlice({
  name: "login",
  initialState,
  reducers: {
    clearOTP: (state) => {
      state.otpData = initialState.otpData;
    },
    setResend: (state, action) => {
      state.resend = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(generateOTP.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(
      generateOTP.fulfilled,
      (state, action: PayloadAction<any>) => {
        state.data = action.payload;
        state.loading = false;
        state.error = "";
        state.otpData = action.payload;
      }
    );
    builder.addCase(generateOTP.rejected, (state, action) => {
      state.loading = false;
      state.otpData = null;
      state.error = action.error.message || "Something went wrong";
    });

    builder.addCase(employeeLogin.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(
      employeeLogin.fulfilled,
      (state, action: PayloadAction<any>) => {
        state.data = action.payload;
        state.loading = false;
        state.error = "";
        const result = action.payload;
        state.loginDetails.UserID = result.ID;
        state.loginDetails.Name = result.Name;
        state.loginDetails.UserName = result.UserName;
        state.loginDetails.EmailID = result.EmailID;
        state.loginDetails.UserTypeID = result.UserTypeID;
        state.loginDetails.UserType = result.UserType;

        if (result?.Token) {
          localStorage.setItem("Token", result?.Token);
          localStorage.setItem("RefreshToken", result?.RefreshToken);
          localStorage.setItem("UserID", result?.ID);
          localStorage.setItem("Name", result?.Name);
          localStorage.setItem("UserName", result?.UserName);
          localStorage.setItem("EmailID", result?.EmailID);
          localStorage.setItem("UserTypeID", result?.UserTypeID);
          localStorage.setItem("UserType", result?.UserType);
          localStorage.setItem(
            "UserRightsAssign",
            JSON.stringify(result?.UserRightsAssign)
          );
        }
      }
    );
    builder.addCase(employeeLogin.rejected, (state, action) => {
      state.loading = false;
      state.data = null;
      state.error = action.error.message || "Something went wrong";
    });
  },
});
export const { clearOTP, setResend } = loginSlice.actions;
export default loginSlice.reducer;
